function membershipPaymentMethod(method) {
	// hide all the old ones
	$('.membership-payment .payment-method input').removeClass('required');
	$('.membership-payment .payment-method input').prop('disabled', true);
	$('.membership-payment .payment-method').hide();

	// show the new one
	$('.membership-payment .payment-method[data-method="'+method+'"]').show();
	$('.membership-payment .payment-method[data-method="'+method+'"] input').prop('disabled', false);
	$('.membership-payment .payment-method[data-method="'+method+'"] input').each(function() {
		var input = $(this);

		if(input.hasClass('disabled')) {
			return true;
		}

		if(input.attr('data-required')) {
			input.addClass('required');
		}
	});
}

function membershipPayment(membership) {
	var action = $('.membership-payment form').attr('data-action').replace('{membership}', membership);
	$('.membership-payment form').attr('action', action);

	// reset the payment method
	$('.membership-payment input[name="method"]').prop('checked', false);
	$('.membership-payment input[name="method"]').parents('li').show();

	// reset the cards
	$('.membership-payment .payment-method[data-method="saved-card"]').hide();
	$('.membership-payment .payment-method[data-method="saved-card"] input[name="card"]').prop('checked', false);
	$('.membership-payment .payment-method[data-method="saved-card"] input[name="card"]').prop('disabled', true);
	$('.membership-payment .payment-method[data-method="saved-card"] input[name="card"]').removeClass('required');
	if(!$('.membership-payment .payment-method[data-method="saved-card"] input[name="card"]').length) {
		$('.membership-payment input[name="method"][value="saved-card"]').prop('checked', false);
		$('.membership-payment input[name="method"][value="saved-card"]').prop('disabled', true);
		$('.membership-payment input[name="method"][value="saved-card"]').parents('li').hide();
	}

	// reset the payment info
	$('.membership-payment .payment-method[data-method="new-card"]').hide();
	$('.membership-payment .payment-method[data-method="new-card"] input').val('');
	$('.membership-payment .payment-method[data-method="new-card"] input').removeClass('required');
	$('.membership-payment .payment-method[data-method="new-card"] input').parents('li').addClass('filled');

	// set the default option
	if($('.membership-payment .payment-method[data-method="saved-card"] input[name="card"]').length) {
		$('.membership-payment input[name="method"][value="saved-card"]').prop('checked', true);
		membershipPaymentMethod('saved-card');
	} else {
		$('.membership-payment input[name="method"][value="new-card"]').prop('checked', true);
		membershipPaymentMethod('new-card');
	}

	openModal('.membership-payment');
}

$('body').on('click', '.buy-membership-trigger', function() {
	var $this = $(this);
    membershipPayment($this.attr('data-membership'));
    return false;
});

$('body').on('change', '.membership-payment input[name="method"]', function() {
    var method = $(this).val();
    membershipPaymentMethod(method);
});

// submitting the membership-payment form
$('body ').on('submit', '.membership-payment form', function() {
	var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;

    modal.find('.required').each(function() {
		var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
	        	console.log('radio', input.attr('name'));
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
        	console.log(input.attr('name'));
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();

    if ($('input[name="card_number"]', $this).hasClass('required')) {
        Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
        Stripe.card.createToken(
            {
                name: $('input[name="card_holder"]', $this).val(),
                number: $('input[name="card_number"]', $this).val(),
                cvc: $('input[name="cvv"]', $this).val(),
                exp_month: $('input[name="month"]', $this).val(),
                exp_year: $('input[name="year"]', $this).val()
            },
            function (status, response) {
                // console.log(response);
                if (response.error) {
                    unloading();
                    showError('Error', response.error.message, 'close');
                    return false;
                }

                fields[fields.length] = { name: 'stripe_token', value: response.id };
                fields[fields.length] = { name: 'brand', value: response.card.brand };
                fields[fields.length] = { name: 'last_four', value: response.card.last4 };
                fields[fields.length] = { name: 'month', value: response.card.exp_month };
                fields[fields.length] = { name: 'year', value: response.card.exp_year };

                $.ajax({
                    type: 'POST',
                    url: $this.attr('action'),
                    data: fields,
                    dataType: 'json',
                    success: function (data) {
                        unloading();
                        console.log(data);

                        if (data.success) {
                            closeModal();
                        }

                        showError(data.success ? 'Success' : 'Error', data.message);
                    },
                    error: function (request) {
                        console.log(request.responseText);
                    }
                });

                return false;
            }
        );
        return false;
    }

    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
        	unloading();
            console.log(data);

            if(data.success) {
            	closeModal();
            }

            showError(data.success ? 'Success' : 'Error', data.message);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });
	return false;
});